import createReactClass from 'create-react-class';

('use strict');

// Import Libraries
import React from 'react';
// Import JS Modules
import { UpdatePhotoEvents } from './events/event-declarations';
import { builderDispatch } from '../../_utils/ui';
import PhotoRemoveConfirmationModal from './photo-remove-confirmation-modal';

// -----------------------------------------------------------
//  PhotoRemoveConfirmation
// -----------------------------------------------------------
const PhotoRemoveConfirmation = createReactClass({
  getInitialState() {
    return {
      isOpen: false,
    };
  },
  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      switch (payload.type) {
        case UpdatePhotoEvents.SHOW_REMOVE_CONFIRMATION:
          this.clientUuid = payload.clientUuid;
          this.useRoot = payload.useRoot;
          this.onCancel = payload.onCancel;
          this.open();
          break;
      }
    });
  },
  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  },
  render() {
    return (
      <PhotoRemoveConfirmationModal
        className="photo-remove-confirmation"
        title="Are you sure you want to remove this photo?"
        isOpen={this.state.isOpen}
        onRemove={this.handleRemove}
        onClose={this.handleCancel}
      />
    );
  },
  open() {
    this.setState({ isOpen: true });
  },
  handleCancel() {
    if (typeof this.onCancel === 'function') {
      this.onCancel();
    }

    this.setState({ isOpen: false });
  },
  handleRemove() {
    builderDispatch.dispatch({
      type: UpdatePhotoEvents.REMOVE,
      clientUuid: this.clientUuid,
      useRoot: this.useRoot,
    });

    this.setState({ isOpen: false });
  },
});

export default PhotoRemoveConfirmation;
